import React, { memo } from "react";
import { Text, View, Page, Document, PDFViewer } from '@react-pdf/renderer';
import "../../components/pdf/Fonts.js"
import styles from "../../components/pdf/Styles.js"

const AvailableLambsPdf = ({
    availableAnimals,
    owner,
}) => {
    return (
        <>
            <PDFViewer style={{ width: '99%', height: '100vh' }}>
                <Document>
                    <Page size='A4' orientation='landscape' style={styles.page} wrap>
                        <View style={styles.topColumn} fixed>
                            <View style={styles.headers_container}>
                                <Text style={styles.headers}>{'Εκτροφή'}</Text>
                                <Text style={styles.headers}>{"Κωδικός Αμνού"}</Text>
                                <Text style={styles.headers}>{"Φυλή"}</Text>
                                <Text style={styles.headers}>{'Ημ/νια τοκετού'}</Text>
                                <Text style={styles.headers}>{'Κωδικός Πατέρα'}</Text>
                                <Text style={styles.headers}>{'Κωδικός Μητέρας'}</Text>
                            </View>
                        </View>
                        <View style={styles.bottomColumns}>
                            {availableAnimals.map((item, index) =>
                                <View key={index} style={styles.cells_container} wrap={false}>
                                    <Text style={styles.cell}>{owner}</Text>
                                    <Text style={styles.cell}>{item?.lambSlug}</Text>
                                    <Text style={styles.cell}>{item?.breedCode}</Text>
                                    <Text style={styles.cell}>{item?.lambingDate ? new Date(item?.lambingDate).toLocaleDateString("el-GR") : ""}</Text>
                                    <Text style={styles.cell}>{item?.sireCode}</Text>
                                    <Text style={styles.cell}>{item?.damCode}</Text>
                                </View>
                            )}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    );
};

export default memo(AvailableLambsPdf);
